import React, { memo } from 'react';
import _ from 'lodash';
import infoIcon from 'img/info.svg';
import { Row, Col } from '@duxton-web/ui';
import { Handle, Position } from 'reactflow';
import actionsCommunicationsIcon from 'img/ucd_actions_communications.svg';
import 'components/journey-builder/css/actions.scss';
import { ACTION_TYPE_TEXT, NODETYPE_REQUIRED_FIELDS, NODE_TYPES } from 'components/journey-builder/utils/constants';
import { getErrors } from 'components/journey-builder/utils/core';
import { MoreInfoFilled } from '@duxton-web/icons';

export default memo(({ data, isConnectable }) => {
  const { isView, showMetrics } = data;
  const action = data;
  const hasError = getErrors(data, NODETYPE_REQUIRED_FIELDS[NODE_TYPES.action]);
  const displayComponent = _.get(action, 'meta.messagingPayload.templateName', '') ?
    (<Row style={{ marginTop: 12 }}>
      <Col>
        <div className="categoryHeader">
          Hedwig template
        </div>
        <div className="categoryContent">
          {_.get(action, 'meta.messagingPayload.templateName', '')}
        </div>
        <div className="templateType">
          {ACTION_TYPE_TEXT[action.type] || ''}
        </div>
      </Col>
    </Row>) :
    (<Row>
      <Col>
        <span>Click to edit the message content</span>
      </Col>
    </Row>);
  return (
    <div>
      {hasError && !isView && <MoreInfoFilled className="hasError" />}
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Row>
        <Col>
          <img src={actionsCommunicationsIcon} height={'28px'} width={'28px'} alt={''} />
        </Col>
        <Col>
          <div className="title">
            <b>Communication #{data.nameIndex}</b>
          </div>
        </Col>
      </Row>
      {displayComponent}
      {showMetrics && data.processed_count > 0 && <div>
        <div className="divider" />
        <Row>
          <Col>
            <div className="progressTextHeader">
              Processed <img src={infoIcon} height={'12px'} width={'12px'} alt={''} />
            </div>
            <div className="progressTextContent">
              {((data.success_count / (data.totalCount || 0)) * 100).toFixed(1)} %
            </div>
          </Col>
        </Row>
      </div>}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </div>
  );
});
